import useReactQuery from '@/hooks/common/useReactQuery';

interface DismissalResponse {
  dismissed: boolean;
}

interface Params {
  enabled: boolean;
}

const URL = '/api/school/parents/app_download_popup_dismissal';
const QUERY_KEY = ['app_download_popup_dismissal'];

const useAppDownloadPopupDismissal = ({ enabled }: Params) => {
  const { useQuery, useMutation, useQueryClient } = useReactQuery();
  const queryClient = useQueryClient();

  const query = useQuery<DismissalResponse>({
    queryKey: QUERY_KEY,
    url: URL,
    enabled,
  });

  const mutation = useMutation({
    method: 'POST',
    url: URL,
    onSuccess: () => {
      queryClient.setQueryData<DismissalResponse>(QUERY_KEY, {
        dismissed: true,
      });
    },
  });

  return { ...query, dismiss: () => mutation.mutate(undefined) };
};

export default useAppDownloadPopupDismissal;
